module.exports = __webpack_public_path__ + "static/media/ISOLogo.92da350d.ico";